import { useState, useRef, useEffect } from 'react';
import './radio.css';

const Radio = ({ name, options, followUpQ, question, handleChangeEvent }) => {

    useEffect(() => {
        const saved = localStorage.getItem(`questions.AIRQ-${question.id}`);
        if (saved) {
            const parsed = JSON.parse(saved);
            setSelectedAnswers(parsed);
            selectedAnswersRef.current = parsed;
        }
    }, [question.id]);

    // const [selectedValue, setSelectedValue] = useState('');
    const [selectedAnswers, setSelectedAnswers] = useState(question.multiSelect ? [] : '');
    const selectedAnswersRef = useRef(selectedAnswers);

    const onChange = (value) => {

        // console.log(question)

        // if timestamp doesn't exist for this question in localStorage, add it
        if (!localStorage.getItem(`questions.TIMESTAMP-${question.id}`)) {
            localStorage.setItem(`questions.TIMESTAMP-${question.id}`, new Date().toISOString());
        }

        // setSelectedValue(value);
        setSelectedAnswers(prevSelectedAnswers => {
            let updatedAnswers;

            if (question.multiSelect) {
                const alreadySelected = prevSelectedAnswers.includes(value);

                if (alreadySelected) {
                    // Remove it if already selected
                    updatedAnswers = prevSelectedAnswers.filter(answer => answer !== value);
                } else {
                    // Add it — but only if we haven't hit the maxCount
                    if (question.maxCount != null && prevSelectedAnswers.length >= question.maxCount) {
                        // Optional: provide user feedback
                        
                        return prevSelectedAnswers; // prevent adding more
                    }
                    updatedAnswers = [...prevSelectedAnswers, value];
                }
            } else {
                updatedAnswers = value;
            }

            // Also update ref and localStorage
            selectedAnswersRef.current = updatedAnswers;
            localStorage.setItem(
                `questions.AIRQ-${question.id}`,
                JSON.stringify(updatedAnswers)
            );

            return updatedAnswers;
        });

        handleChangeEvent();
    };

    return (
        <div className="radio-group">
            {options.map((option, idx) => (
                <div className="radio-option-wrapper" key={idx}>
                    <label key={option.value} className="radio-label">
                        <input
                            className="radio-input"
                            type={question.multiSelect ? 'checkbox' : 'radio'}
                            checked={question.multiSelect
                                ? selectedAnswers.includes(option.id)
                                : selectedAnswers === option.id
                            }
                            onChange={() => onChange(option.id)}
                        />
                        <div className="radio-label-wrapper">{option.label}</div>

                        {option.followUp && (
                            <input
                                className="follow-up-input"
                                placeholder={
                                    localStorage.getItem(`questions.FOLLOWUP-${question.id}`) ||
                                    question.followUpQuestion
                                }
                                onChange={(e) => {
                                    localStorage.setItem(
                                        `questions.FOLLOWUP-${question.id}`,
                                        JSON.stringify(e.target.value)
                                    );
                                }}
                            />
                        )}
                    </label>
                </div>
            ))}
        </div>
    );
};

export default Radio;
